export default () => {
  const data = {
    event_name: 'tapped_text_field',
    button_name: 'address',
    page_section: 'search_properties',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
